import { render, staticRenderFns } from "./ChatChatOpt.vue?vue&type=template&id=0e47d0c2&"
import script from "./ChatChatOpt.vue?vue&type=script&lang=js&"
export * from "./ChatChatOpt.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatOpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports